import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-accounts-configuration',
  templateUrl: './accounts-configuration.component.html',
  styleUrls: ['./accounts-configuration.component.scss']
})
export class AccountsConfigurationComponent implements OnInit {
  accountSelected = null;
  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  creating = false;
  edit = 0;
  newAccount: AccountResponse = new AccountResponse();
  alwaysCreating = false;
  accountOptions: AccountOptionResponse = null;

  constructor(
    private accService: AccountService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.accService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts;
        this.getAccountOptions();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getAccountOptions(){
    this.accService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
        this.newAccount.bank = this.accountOptions.erpBanks[0].id;
        this.newAccount.bankAccountType = this.accountOptions.bankAccountTypes[0].id;
        this.newAccount.currency = this.accountOptions.currencies[0].id;
        this.newAccount.international = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getAccounts(){
    this.accService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  reset() {
    this.newAccount = new AccountResponse();
    this.newAccount.bank = this.accountOptions.erpBanks[0].id;
    this.newAccount.bankAccountType = this.accountOptions.bankAccountTypes[0].id;
    this.newAccount.currency = this.accountOptions.currencies[0].id;
    this.newAccount.international = false;
  }

  getBankName(id:number){
    var temp = this.accountOptions.erpBanks.find((b)=>{
      return b.id == id;
    });

    return temp.name;
  }

  getBankAccountTypeName(id:number){
    var temp = this.accountOptions.bankAccountTypes.find((b)=>{
      return b.id == id;
    });

    return temp.name;
  }

  getCurrencyName(id:number){
    var temp = this.accountOptions.currencies.find((b)=>{
      return b.id == id;
    });

    return temp.name;
  }

  cancel() {
    if (!this.alwaysCreating) {
      this.creating = false
    }
    this.reset();
  }

  create() {
    this.newAccount.withInitialBalance = this.newAccount.balance?true:false;
    this.accService.saveAccount(this.newAccount).subscribe({
      next: (response: ResponseObject) => {
        this.getAccounts();
        this.toastService.success("Se guardo correctamente la cuenta bancaria");
        if (!this.alwaysCreating) {
          this.creating = false
        }
        this.reset();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  activeOrInactive(account: any) {
    this.accService.activeOrInactive(account.id).subscribe({
      next: (response: any) => {
        account.active = !account.active;
        this.toastService.success("Se ha " + ((account.active) ? 'activado' : 'desactivado') + " correctamente la cuenta bancaria");
      },
      error: (error: any) => {
        this.toastService.success("Error al " + (account.active) ? 'desactivar' : 'activar' + " la cuenta bancaria");
      }
    })
  }

  editAndSave(account: any) {
    if (this.edit == account.id) {
      //saving
      this.accService.putAccount(account.id, account).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Cuenta bancaria modificada correctamente");
        },
        error: (error: any) => {
          this.toastService.error("Error al modificar la cuenta");
        }
      })
      this.edit = 0;
    } else {
      this.edit = account.id;
    }
  }
}
